import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import DetailsRoutes from './details/details-routing';
import EditRoutes from './edit/edit-routing';
import ListRoutes from './list/list-routing';
import ManageContentRoutes from './manage-content/manage-content-routing';

@NgModule({
  imports: [RouterModule.forRoot([
    { children: ListRoutes, path: '' },
    { children: DetailsRoutes, path: 'publications/:id/details' },
    { children: EditRoutes, path: 'publications/:id/edit' },
    { children: ManageContentRoutes, path: 'publications/:id/manage-content' },
  ])],

  exports: [ RouterModule ],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/app-routing.module.ts